import React from 'react';
import styled from 'styled-components';
import { SectionParent, H1 } from '../StyledComponents';
import { StaticQuery, graphql } from 'gatsby';
import GatsbyImage from 'gatsby-image';

const PartnersSection = styled(SectionParent)`
  display: grid;
  justify-items: center;
  width: 100%;
  border-bottom: 1px #f6f8fb solid;
  background-color: #fff;
`;
const ManageHeading = styled.div`
  text-align: center;
  color: #2d2b33;
  margin-top: 5rem;

  @media (max-width: 520px) {
    margin-top: 1rem;
  }
`;

const ManageSecondHeading = styled(ManageHeading)`
  color: #2d2b33;
`;

const PartnersGrid = styled.div`
  display: grid;
  grid-template-columns: ${(props: { count: number }) =>
    `repeat(${props.count}, 1fr)`};
  grid-gap: 70px;
  /* grid-gap: 3rem; */
  margin-top: 4rem;
  margin-bottom: 4rem;
  @media (max-width: 1100px) {
    grid-gap: 50px;
  }
  @media (max-width: 900px) {
    grid-gap: 40px;
  }
  @media (max-width: 768px) {
    grid-gap: 70px;
    grid-template-columns: repeat(2, 1fr);
  }
  @media (max-width: 520px) {
    grid-gap: 20px;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 1.5rem;
    margin-bottom: 1rem;
    margin-top: 1rem;
  }
`;

const PartnersItem = styled(GatsbyImage)`
  width: 130px;
  height: 80px;
  max-width: 100%;
  align-self: center;
  opacity: 0.9;
  transition: opacity 0.2s ease-in-out;
  &:hover {
    opacity: 1;
  }
  @media (max-width: 1100px) {
    width: 100px;
  }
  @media (max-width: 768px) {
    width: 10rem;
  }
  @media (max-width: 520px) {
    width: 30vw;
    height: 50px;
  }
  img {
    object-fit: contain !important;
  }
`;

export default (props: any) => (
  <StaticQuery
    query={graphql`
      query {
        lenovo: file(
          relativePath: { eq: "v2/png/careers/partners/lenovo-color.png" }
        ) {
          childImageSharp {
            fluid(quality: 95) {
              aspectRatio
              src
              srcSet
              sizes
              srcWebp
              srcSetWebp
            }
          }
        }

        zebra: file(
          relativePath: { eq: "v2/png/careers/partners/zebra-color.png" }
        ) {
          childImageSharp {
            fluid(quality: 95) {
              aspectRatio
              src
              srcSet
              sizes
              srcWebp
              srcSetWebp
            }
          }
        }

        android: file(
          relativePath: { eq: "v2/png/careers/partners/android.png" }
        ) {
          childImageSharp {
            fluid(quality: 95) {
              aspectRatio
              src
              srcSet
              sizes
              srcWebp
              srcSetWebp
            }
          }
        }

        innocom: file(
          relativePath: { eq: "v2/png/careers/partners/innocom.png" }
        ) {
          childImageSharp {
            fluid(quality: 95) {
              aspectRatio
              src
              srcSet
              sizes
              srcWebp
              srcSetWebp
            }
          }
        }

        gemalto: file(
          relativePath: { eq: "v2/png/careers/partners/android.png" }
        ) {
          childImageSharp {
            fluid(quality: 95) {
              aspectRatio
              src
              srcSet
              sizes
              srcWebp
              srcSetWebp
            }
          }
        }

        mediateknew: file(
          relativePath: { eq: "v2/png/careers/partners/mtklogo.png" }
        ) {
          childImageSharp {
            fluid(quality: 95) {
              aspectRatio
              src
              srcSet
              sizes
              srcWebp
              srcSetWebp
            }
          }
        }

        mediatek: file(
          relativePath: { eq: "v2/png/careers/partners/mediatek-color.png" }
        ) {
          childImageSharp {
            fluid(quality: 95) {
              aspectRatio
              src
              srcSet
              sizes
              srcWebp
              srcSetWebp
            }
          }
        }
      }
    `}
    render={(data: any) => (
      <PartnersSection>
        <ManageSecondHeading>
          <H1 style={{ color: '#000f16' }}>
            {props.messages?.ContactUsPagePartnerInfo}
          </H1>
        </ManageSecondHeading>
        <PartnersGrid count={props.companies.length}>
          {props.companies.map((item: any) => {
            return (
              <PartnersItem
                key={item}
                loading="lazy"
                fluid={data[`${item}`].childImageSharp.fluid}
                alt={item}
              />
            );
          })}
        </PartnersGrid>
      </PartnersSection>
    )}
  />
);
